import React from 'react';

const InfoCard = ({ icon, title, description }) => {
  return (
    <div className="border border-[#7f56d9] rounded-2xl px-6 py-8 w-full text-start grid gap-4 grid-rows-[auto_auto_1fr]">
      <img src={icon} alt={title} className="w-16 h-16" />
      <h3 className="font-semibold text-xl text-[#585aac]">{title}</h3>
      <p className="text-sm text-gray-700">{description}</p>
    </div>
  );
};

export default InfoCard;
